import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from URL fragment
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

        if (!sessionId) {
          console.error('No session_id found');
          navigate('/auth');
          return;
        }

        // Get API URL from environment
        const API = process.env.REACT_APP_BACKEND_URL;

        // Exchange session_id for user data
        const response = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId
        });

        const { token, user } = response.data;

        // Store token and user
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));

        // Set default auth header
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        // Clear the URL hash and redirect to dashboard
        window.history.replaceState({}, document.title, '/dashboard');
        navigate('/dashboard', { state: { user }, replace: true });

      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/auth');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#F5F5F0] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#1A4D2E] animate-spin mx-auto mb-4" />
        <p className="text-[#4a5568]">Se procesează autentificarea...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
